var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vehicle-status-panel',{attrs:{"title":"捷卫士车辆状态查询","source":"jws","use-jws-api":true}})}
var staticRenderFns = []

export { render, staticRenderFns }